import React, { Component } from 'react';
import Video from './elements/Video';
import Paragraph from './elements/Paragraph';
import Assetblock from './elements/Assetblock';
import Iframe from './elements/Iframe';
import { generateKey } from '../utils/utils.js'

class PostGrid extends Component {
  static defaultProps = {
    postImages: [],
    postContent: []
  }
  render() {
    return (
      <div className="post-grid" >
          {this.props.postContent.content.map((content,index) => {
            if (content.nodeType === "embedded-asset-block") {
              return <Assetblock content={content} key={generateKey(index)} index={index}/>
            } else if (content.nodeType === "paragraph" && content.content[0].value.includes('iframe')) {
              return <Iframe content={content} key={generateKey(index)} index={index}/>
            } else if (content.nodeType === "paragraph" || content.nodeType === "text") {
              if (content.content[0].value.includes('youtube') || content.content[0].value.includes('vimeo')) {
               return <Video content={content} key={generateKey(index)} index={index} />
            } else {
               return <Paragraph key={generateKey(index)} content={content} index={index}/>
              }
            } else {
              return null;
            }
          })}
      </div>
    );
  }
}

export default PostGrid;



// WEBPACK FOOTER //
// ./src/Posts/PostGrid.js